import { render, staticRenderFns } from "./denglu.vue?vue&type=template&id=06bd60b0&scoped=true"
import script from "./denglu.vue?vue&type=script&lang=js"
export * from "./denglu.vue?vue&type=script&lang=js"
import style0 from "./denglu.vue?vue&type=style&index=0&id=06bd60b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd60b0",
  null
  
)

export default component.exports